import { render } from "./FacilitySettings.vue?vue&type=template&id=51f80668"
import script from "./FacilitySettings.vue?vue&type=script&lang=js"
export * from "./FacilitySettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/commercialSettings/FacilitySettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51f80668"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51f80668', __exports__)) {
    console.log('reload')
    api.reload('51f80668', __exports__)
  }
  
  module.hot.accept("./FacilitySettings.vue?vue&type=template&id=51f80668", () => {
    console.log('re-render')
    api.rerender('51f80668', render)
  })

}


export default __exports__